module.exports = __webpack_public_path__ + "static/TEKDiagramShakePro-ec4d6956a934633ab66f0b8ce60c8397.mp4";